import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Categories from "@/pages/Categories";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import SellerProfile from "@/pages/SellerProfile";
import Dashboard from "@/pages/Dashboard";
import ProductForm from "@/pages/ProductForm";
import Purchases from "@/pages/Purchases";
import Favorites from "@/pages/Favorites";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Help from "@/pages/Help";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/explore" element={<Explore />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/seller/:id" element={<SellerProfile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/new" element={<ProductForm />} />
                <Route path="/dashboard/edit/:id" element={<ProductForm />} />
                <Route path="/purchases" element={<Purchases />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/help" element={<Help />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </FavoritesProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
